// extracted by mini-css-extract-plugin
module.exports = {"root":"CookiePop_root__endn4","link":"CookiePop_link__Nnfp_","text":"CookiePop_text__AGXEI"};